package com.gastoncantera.intercom.config

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.remoteconfig.remoteConfig
import kotlinx.serialization.json.Json
import kotlin.time.Duration.Companion.seconds

private const val APP_CONFIG_KEY = "app_config"

/**
 * Kill switch global (solo web): QR de portero + auth anónima.
 * Boolean en Firebase Remote Config. Sin parámetro o `false` = off.
 */
const val WEB_QR_ENABLED_KEY = "web_qr_enabled"

data class RemoteSettings(
    val config: AppConfig,
    val webQrEnabled: Boolean,
)

/**
 * Trae la configuración de la app desde Firebase Remote Config (parámetro [APP_CONFIG_KEY],
 * cuyo valor es el JSON de `app-config.json`) y la parsea al dominio normalizado.
 */
class ConfigRepository {
    private val remoteConfig = Firebase.remoteConfig
    private val json = Json { ignoreUnknownKeys = true }

    suspend fun loadSettings(): RemoteSettings {
        // Sin caché: es lo que hace que reiniciar la app sea un camino confiable para tomar un
        // cambio recién publicado, y que la relectura periódica de App realmente vaya al server. No
        // hay riesgo de throttling porque nadie llama a esto seguido (arranque + una vez por hora).
        remoteConfig.settings { minimumFetchInterval = 0.seconds }
        remoteConfig.fetchAndActivate()
        val raw = remoteConfig.getValue(APP_CONFIG_KEY).asString()
        val dto = json.decodeFromString<Map<String, ConsorcioDto>>(raw)
        return RemoteSettings(
            config = dto.toAppConfig(),
            webQrEnabled = readWebQrEnabled(),
        )
    }

    /** Sin parámetro publicado → off. Kill switch = publicar `false` (o borrar el parámetro). */
    private fun readWebQrEnabled(): Boolean {
        val value = remoteConfig.getValue(WEB_QR_ENABLED_KEY)
        if (value.asString().isEmpty()) return false
        return value.asBoolean()
    }
}
